<template>
  <div>
    <iframe
      :src="url"
      frameborder="0"
      id="myiframe"
      width="100%"
      height="800"
      allowtransparency
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url:
        process.env.VUE_APP_REPORTING_URL + "public/dashboard/6737ab43-51af-419b-8a9a-5eb5d7cdf583"
    };
  },
  created() {
  },
};
</script>
